import React, {useEffect, useState} from 'react'
import sessionManager from '../util/sessionManager'
import useSiteMetadata from '../util/useSiteMetadata'
import LayoutContainer from './LayoutContainer'
import FullPageSpinner from './FullPageSpinner'
import LoginPrompt from './LoginPrompt'
import DeploymentPrompt from './DeploymentPrompt'


export default function SessionContainer(props) {

  const [global, setGlobal] = useState(sessionManager.getState())

  useEffect(function () {
    return sessionManager.subscribe(function () {
      setGlobal(sessionManager.getState())
    })
  }, [])



  const siteMeta = useSiteMetadata()
  sessionManager.assertMeta(siteMeta)



  const queryString = props.location.search
  const match = (/\?code=([\w\-\.]+)/).exec(queryString)
  const auth_code = match && match[1]

  if (auth_code) {
    if (!global.pending_auth_code) {
      sessionManager.dispatch({
        type: 'RECEIVE_AUTH_CODE',
        data: {
          auth_code,
          location: props.location,
        },
      })

      props.navigate('/', {replace: true})
    }

    return <FullPageSpinner />
  }



  if (!global || !global.auth_state_sync || !global.socket_ready) {
    return <FullPageSpinner />
  }



  if (!global.current_user_vuid) {
    return (
      <LoginPrompt
        global={global}
        dispatch={sessionManager.dispatch}
        location={props.location}
        siteMeta={siteMeta}
      />
    )
  }



  if (!global.current_user_active_deployment_id) {
    return (
      <DeploymentPrompt
        global={global}
        dispatch={sessionManager.dispatch}
        location={props.location}
        siteMeta={siteMeta}
      />
    )
  }



  return (
    <LayoutContainer
      global={global}
      dispatch={sessionManager.dispatch}
      location={props.location}
    >
      {props.children}
    </LayoutContainer>
  )
}
